package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px
import org.lennycodes.hldi.constants.HLDITheme

val MobileNavDiv = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Block) // default visible
            .cursor(Cursor.Pointer)
            .fontSize(24.px)
            .color(HLDITheme.Colors.text)
    }
    cssRule("@media (min-width: 1281px)") {
        Modifier.display(DisplayStyle.None)
    }
}